module.exports = __webpack_public_path__ + "img/thumb-004-10.0c8efc2f.png";